import { MgdRoutes } from "./interfaces/route";
import { CommonAppRouteId } from "./enums/common-app-route-id";
import { errorMessageResolver } from "./resolvers/error-message.resolver";

/**
 * These routes are side-loaded with the app routes by the AppUtil.configureApp. They are common to all applications
 */
export const COMMON_APP_ROUTES: MgdRoutes = [
    {
        path: "error",
        resolve: {
            // This will set the error message to the error message attached to the navigation state
            errorMessage: errorMessageResolver
        },
        data: {
            routeId: CommonAppRouteId.Error
        },
        loadComponent: () => import("./views/error-page/error-page.component").then((m) => m.ErrorPageComponent)
    },
    {
        path: "**",
        data: {
            // The error message is hardcoded for not found errors
            errorMessage: "We are unable to find what you are looking for."
        },
        loadComponent: () => import("./views/error-page/error-page.component").then((m) => m.ErrorPageComponent)
    }
];
